module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "timeline",
    staticClass: "timeline",
    class: _vm.windowWidth <= 768 ? 'wow fadeIn' : null,
    attrs: {
      "data-wow-delay": "0.3s"
    }
  }, [_c('header', {
    staticClass: "timeline__intro",
    class: _vm.windowWidth > 768 ? 'wow fadeInRight' : null,
    attrs: {
      "data-wow-delay": "0.3s"
    }
  }, [_c('div', {
    staticClass: "timeline__heading-container"
  }, [_vm._t("heading")], 2), _vm._v(" "), _c('div', {
    staticClass: "timeline__copy-container"
  }, [_vm._t("copy")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "timeline__year-list-container"
  }, [(_vm.events) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeEvent),
      expression: "activeEvent"
    }],
    staticClass: "timeline__year-list",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeEvent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.eventsSorted), function(event, index) {
    return _c('option', {
      key: index,
      staticClass: "timeline__year-item",
      class: event === _vm.activeEvent ? 'timeline__year-item--active' : null,
      domProps: {
        "value": event,
        "textContent": _vm._s(event.year)
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "timeline__year-line-list",
    on: {
      "click": function($event) {
        _vm.timelineActive = false
      }
    }
  }, _vm._l((_vm.eventsSorted), function(event, index) {
    return _c('li', {
      key: index,
      staticClass: "timeline__year-line-item",
      class: event === _vm.activeEvent ? 'timeline__year-line-item--active' : null
    }, [_c('button', {
      staticClass: "timeline__year-line-button",
      domProps: {
        "textContent": _vm._s(event.year)
      },
      on: {
        "click": function($event) {
          _vm.activeEvent = event
        }
      }
    })])
  })), _vm._v(" "), _c('section', {
    staticClass: "timeline__events-container",
    on: {
      "click": function($event) {
        _vm.timelineActive = false
      }
    }
  }, [_c('div', [_c('ul', {
    staticClass: "timeline__events",
    style: (_vm.eventsStyles)
  }, _vm._l((_vm.events), function(event, index) {
    return _c('li', {
      key: index,
      staticClass: "timeline__event",
      class: event === _vm.activeEvent ? 'timeline__event--active' : null,
      on: {
        "click": function($event) {
          _vm.activeEvent = event
        }
      }
    }, [_c('article', {
      staticClass: "timeline__event-content"
    }, [_c('h4', {
      staticClass: "timeline__event-year",
      domProps: {
        "textContent": _vm._s(event.year)
      }
    }), _vm._v(" "), _c('h5', {
      staticClass: "timeline__event-heading",
      domProps: {
        "textContent": _vm._s(event.heading)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "timeline__event-description",
      domProps: {
        "textContent": _vm._s(event.description)
      }
    })])])
  })), _vm._v(" "), _c('article', {
    staticClass: "timeline__events-reveal"
  }, [_c('div', {
    staticClass: "timeline__events-reveal-container"
  }, [_vm._t("reveal-heading"), _vm._v(" "), _vm._t("reveal-copy"), _vm._v(" "), _vm._t("reveal-button")], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92ed6978","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandTimeline.vue
// module id = 268
// module chunks = 1